import { Component, Input, OnChanges } from '@angular/core';

@Component({
  selector: 'app-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrls: [`./progress-bar.component.scss`]
})
export class ProgressBarComponent implements OnChanges {

  @Input() public amount;
  @Input() public goal;
  @Input() public height = '6px';
  percentage;

  constructor() { }

  ngOnChanges(): void {
    this.setProgressbar();
  }
  /** Set progress bar */
  setProgressbar(): void {
    const amount = this.amount;
    const goal = this.goal;
    this.percentage = (amount / goal) * 100 + '%';
  }

}
